import React from 'react';
import { Divider as SUIDivider, Segment } from 'semantic-ui-react';

const SemanticDividerView = ({ data = {} }) => {
  const {
    color,
    thickness,
    narrow = true,
    style = {},
  } = data;


  return (
    <Segment basic>
      <SUIDivider
        style={{
          borderTop: `${thickness} solid ${color}`,
          ...style,
        }}
        className={narrow ? 'semantic-divider-narrow' : ''}
      >
      </SUIDivider>
    </Segment>
  );
};

export default SemanticDividerView;